import type { ComponentType } from 'react';

import { UploadCard, type UploadCardProps } from '../../UploadCard/UploadCard';

type SmartTaxUploadCardProps = Pick<
  UploadCardProps,
  'onDrop' | 'disabled' | 'multiple' | 'maxFiles' | 'compact'
>;

export function createSmartTaxUploadCard(
  config: Omit<UploadCardProps, 'onDrop' | 'technicalSpecs' | 'disabled'>,
  TechnicalSpecs: ComponentType
) {
  return function SmartTaxUploadCard({
    onDrop,
    disabled,
    multiple,
    maxFiles,
    compact,
  }: SmartTaxUploadCardProps) {
    return (
      <UploadCard
        {...config}
        onDrop={onDrop}
        technicalSpecs={<TechnicalSpecs />}
        disabled={disabled}
        multiple={multiple}
        maxFiles={maxFiles}
        compact={compact}
      />
    );
  };
}
